import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import loadjs from 'loadjs';
import {
  Subject,
  Subscription,
  firstValueFrom,
  switchMap,
  timeout,
  timer,
} from 'rxjs';
import { TransactionData } from '../api-request';
import { ApiResponse, TransactionFees } from '../api-response';
import { AppService } from '../app.service';
import { CryptoHelper } from '../crypto-helper';
import { PaymentProcessor, StringHelper } from '../strings-helper';
import { environment } from 'src/environments/environment';
import { postTransactionMessage } from '../events';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SvgComponent } from '../svg/svg.component';
import { OtpInputComponent } from '../otp-input/otp-input.component';

declare var dftp: any;
@Component({
  selector: 'card-channel',
  templateUrl: './card-channel.component.html',
  styleUrls: ['./card-channel.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SvgComponent,
    OtpInputComponent,
  ],
})
export class CardChannelComponent
  implements OnChanges, OnInit, AfterViewInit, OnDestroy
{
  @Output() onRedirect: any = new EventEmitter<any>();
  @Output() onComplete: any = new EventEmitter<any>();
  @Output() onFeeChange = new EventEmitter<{ amount: number; fee: number }>();
  @Input() activeTab: any = null;

  isInternationalCard = false;
  private lastBinChecked: string | null = null;
  private cardNoSub?: Subscription;
  private binCheckSubject = new Subject<string>();
  private binCheckSub?: Subscription;

  cardType: any;
  cardPaymentForm: FormGroup;
  payerEnrollForm: FormGroup;
  otpCode!: string;
  otp: string[] = new Array(6).fill('');
  otpArray = Array.from(this.otp);
  // 10 minutes from now
  time_in_minutes = 10;

  display: string = `${10} minutes`;
  public timerInterval: any;
  paymentCard: any;
  showSavedCardsArrow: boolean = false;
  @ViewChild('savedCardsList') savedCardsList!: ElementRef<HTMLElement>;

  cards: any[] = [
    {
      cardName: 'Ridwan Odebiyi',
      cardNumber: '**** **** **** 7878',
    },
    {
      cardName: 'Ridwan Odebiyi',
      cardNumber: '**** **** **** 7878',
    },
  ];
  cardChecked: boolean = false;

  transactionData!: TransactionData;
  amount: any;
  currency: any;
  transactionFees!: TransactionFees;
  subtotal: any;
  // verifyingTransfer: boolean = false;

  state = {
    visible: false,
    isInitialized: false,
    completed: false,
    isFilling: true,
    verifyingTransfer: false,
    showSavedCard: false,
    pinSection: false,
    payerEnroll: false,
    loaded: false,
    error: false,
  };
  responseData: any;
  reference!: string;
  errorMessage!: string;
  loading: boolean = false;
  visaPin: string = '1234';
  showPin: boolean = false;
  tokenizeCard: boolean = false;
  hasSavedCard: boolean = false;
  private scriptLoaded$ = new Subject<void>();
  profilerOptions = {
    attemptReference: '', // inserted by the backend
    sensitiveFields: ['cvv', 'pan', 'pin', 'exp'], // list of sensitive fields
  };
  // @ViewChild('iframe', { static: true }) iframe!: ElementRef;
  iframe!: HTMLIFrameElement;
  cardinalCallbackUrl: string = 'https://zestpayment.com/loader.html';
  // 'https://uat.digicoreltd.com/loader.html'
  queryTime: number = environment.txnQueryTime / 2; // 10 minutes
  isIntervalActive: boolean = true;
  callback: any = {};
  browserIp: string = 'Unknown';

  private setState(key: any, value: any) {
    this.state = { ...this.state, [key]: value };
    this.cd.detectChanges();
  }

  private timer$: Subscription | undefined;

  trustedHTML: any;

  @ViewChild('myDiv', { static: false }) myDiv!: ElementRef;
  paymentProcessor: any;
  referenceId!: string;
  countries: any[] = [];
  localities: any[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private el: ElementRef,
    private appService: AppService,
    private cd: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
  ) {
    this.cardPaymentForm = this.formBuilder.group({
      cardNo: new FormControl('', [
        Validators.required,
        Validators.pattern(/^\d[\d\s]*$/),
      ]),
      expiryDate: new FormControl('', [
        Validators.required,
        Validators.pattern(/^\d{1,2}\/?\d{0,2}$/),
      ]),
      cvv: new FormControl('', [
        Validators.required,
        Validators.pattern(/^\d+$/),
      ]),
      pin: new FormControl(''),
    });

    this.payerEnrollForm = this.formBuilder.group({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      locality: new FormControl('', [Validators.required]),
      country: new FormControl('', [Validators.required]),
      address1: new FormControl('', [Validators.required]),
    });

    // The control, not the DOM node, drives everything that reacts to the PAN,
    // so this keeps working however the value arrives (typing, paste, autofill,
    // patchValue) and however many times the input element gets recreated.
    this.cardNoSub = this.cardPaymentForm
      .get('cardNo')!
      .valueChanges.subscribe((value) => {
        this.applyCardType(value);
        this.evaluateBinForPan(value);
      });

    // switchMap cancels any in-flight BIN lookup as soon as a newer one is
    // requested, so a slow response for an earlier (now-superseded) bin can
    // never overwrite the result of a later one typed/pasted right after it.
    this.binCheckSub = this.binCheckSubject
      .pipe(
        switchMap((bin) =>
          this.appService.getCardTransactionFee({
            bin,
            channel: 'WEB',
            amountInMinor: String(StringHelper.toMinorAmount(this.subtotal)),
          }),
        ),
      )
      .subscribe({
        next: (res: any) => {
          if (res?.success) {
            this.applyBinResult({
              international: res.data?.issuerRegion === 'INTERNATIONAL',
              fee: res.data?.transactionFee,
            });
          }
        },
        error: (err: any) => {
          console.log(err);
        },
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.state.visible) {
      if (changes['activeTab'].currentValue == 'card-tab') {
        this.setState('isFilling', true);
        this.setState('error', false);
        this.cardType = '';
        this.showPin = false;
        this.updatePinValidator();
      }
    }
  }

  ngAfterViewInit(): void {
    console.log('after view init');

    this.appService.getData().subscribe({
      next: (res) => {
        if (res) {
          this.transactionData = res.txnData;
          this.reference = res.txnRef;
          this.hasSavedCard = res.savedCard;
          this.transactionFees = res.transactionFees;
          this.subtotal = res.subtotal;
          this.currency = res.txnData.currency;

          // This component stays mounted between transactions, so always apply
          // a result rather than only overriding the default when one is
          // stored — otherwise a previous transaction's international card
          // would still be flagged against this one.
          const savedFee = this.appService.getCardFeeState(this.reference);
          this.lastBinChecked = null;
          this.applyBinResult(
            savedFee
              ? {
                  international: savedFee.international,
                  fee: savedFee.feeMinor,
                }
              : { international: false },
          );

          this.cd.detectChanges();
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
    // Check if amount is NGN and greater than 500 before calling startNethoneScript
    if (!(this.currency === 'NGN' && +this.amount <= 500)) {
      // this.startNethoneScript();
    }
  }

  ngOnInit(): void {
    window.addEventListener('message', this.handleEvent, false);
  }

  handleEvent = (event: any) => {
    // Validate origin properly
    const trustedOrigins = [
      'https://centinelapistag.cardinalcommerce.com',
      'https://centinelapi.cardinalcommerce.com',
    ];

    if (trustedOrigins.includes(event.origin)) {
      try {
        const obj = JSON.parse(event.data);

        this.referenceId = obj.SessionId;

        if (obj.Status) {
          this.payerEnrollSubmit();
        } else {
          this.errorMessage =
            'We are unable to complete your request at this time. Please try again later.';
          this.setState('error', true);
        }
      } catch (error) {
        console.error('Error parsing JSON:', error);
      }
    }
  };

  // if (typeof event.data == 'object') {

  // }

  async onSubmitBtnClicked() {
    this.loading = true;
    const cardValue = this.cardPaymentForm.value;
    const maxCardInputLength = 19;

    const authData = {
      pan: StringHelper.formatCardPan(cardValue.cardNo, maxCardInputLength),
      pin: cardValue.pin,
      cvv2: cardValue.cvv,
      expiryDate: this.refineValue(cardValue.expiryDate),
    };

    const data: any = {
      cardRequestType: 'INITIATE_CARD_PAYMENT',
      email: this.transactionData.email,
      transactionRef: this.reference,
      currency: this.transactionData.currency,
    };

    if (this.tokenizeCard) {
      data['tokenizeCard'] = this.tokenizeCard;
      data['merchantApiKey'] = this.transactionData.key;
    }

    try {
      const res: any = await firstValueFrom(
        this.appService.getBrowserIP().pipe(timeout(3000)),
      );
      this.browserIp = res?.ip ?? 'Unknown';
    } catch {
      this.browserIp = 'Unknown';
    }

    const deviceInformation = {
      httpBrowserLanguage: navigator.language,
      httpBrowserJavaEnabled: navigator.javaEnabled(),
      httpBrowserJavaScriptEnabled: true,
      httpBrowserColorDepth: screen.pixelDepth,
      httpBrowserScreenHeight: screen.height,
      httpBrowserScreenWidth: screen.width,
      httpBrowserTimeDifference: new Date().getTimezoneOffset(),
      userAgentBrowserValue: navigator.userAgent,
      deviceChannel: 'browser',
      browserIP: this.browserIp,
    };

    // No plaintext fallback: if the card data can't be encrypted, nothing is sent.
    let encryptedAuthData: string;
    try {
      encryptedAuthData = await this.encryptAuthData(authData);
    } catch (err) {
      console.log(err);
      this.loading = false;
      this.showEncryptionError();
      return;
    }

    const cardData = {
      ...data,
      authData: encryptedAuthData,
      deviceInformation,
    };

    // if (!(this.currency === 'NGN' && +this.amount <= 500)) {
    //   this.sendProfile();
    // }

    this.appService.initiateCardPayment(cardData).subscribe({
      next: (res) => {
        this.loading = false;
        if (res?.success) {
          switch (res.data.code) {
            case '00':
              this.paymentDone();
              break;
            case '01':
              this.setState('pinSection', true);
              break;
            case '02':
              this.openVisaForm(res.data);
              break;
            case '03':
              this.authenticateMasterCardPayment(authData);
              break;
            case '04':
              this.authenticateCyberSourcePayment(res.data);
              break;
            case '05':
              this.authenticateVerveMPGSPayment(res.data);
              break;
            default:
              this.errorMessage =
                'We are unable to complete your request at this time, Please try again later';
              this.setState('error', true);
              break;
          }
        } else {
          this.appService.invalidateEncryptionKey();
          this.errorMessage = StringHelper.getErrorMessage(res);
          this.setState('isFilling', false);
          this.setState('error', true);
          this.cardPaymentForm.reset(undefined, { emitEvent: false });
          this.paymentFailed();
        }
      },
      error: (err) => {
        console.log(err);
        this.appService.invalidateEncryptionKey();
        this.errorMessage = StringHelper.getErrorMessage(err.error);
        this.loading = false;
        this.setState('isFilling', false);
        this.setState('error', true);
        this.cardPaymentForm.reset(undefined, { emitEvent: false });
        this.paymentFailed();
      },
    });
  }

  refineValue(value: string) {
    const split = value.split('/');
    return split[1] + '' + split[0];
  }

  checkIframeContentChange() {
    // detecting if iframe URL has changed
    this.cd.detectChanges();
    this.confirmTransaction();
  }

  openVisaForm(data: any) {
    this.onRedirect.emit();
    this.paymentProcessor = PaymentProcessor.IPG;
    const iframe = document.createElement('iframe');
    (iframe.setAttribute('frameBorder', '0'),
      iframe.setAttribute('allowtransparency', 'true'),
      iframe.setAttribute('id', 'cardinalTarget'));
    const html = `<!DOCTYPE html>
    <html lang="en">
    <head>
    <style>
      #form1 {
        opacity:0
      }
    </style>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta http-equiv="X-UA-Compatible" content="ie=edge">
    <title>Zest VISA Checkout</title>
    </head>
    <body>
    <form id="form1" action=${data.acsUrl} method="post">
      <input name="JWT" value=${data.jwt}>
      <input name="MD" value=${data.md}>
    </form>
    </body>
    <script type="text/javascript">
      var body = document.getElementsByTagName("body")[0];
      body.addEventListener("load", document.getElementById('form1').submit(), false);
    </script>
    </html>`;

    iframe.style.cssText =
      'z-index: 999999999999999;background: #FFF;border: 0px none transparent;overflow-x: hidden;overflow-y: hidden;margin: 0;padding: 0;-webkit-tap-highlight-color: transparent;-webkit-touch-callout: none;position: fixed;left: 0;top: 0;width: 100%;height: 100%';
    document.body.appendChild(iframe);
    iframe.src = 'about:blank';

    const handleLoad = () => {
      iframe.removeEventListener('load', handleLoad); // Remove the event listener after it fires
      this.checkIframeContentChange(); // detecting if iframe content has changed
    };

    iframe.addEventListener('load', handleLoad);
    const iWindow = iframe.contentWindow;
    iWindow?.document.open();
    iWindow?.document.write(html);
    iframe.onload = () => {
      // detecting if iframe content has changed
      this.checkIframeContentChange();
    };
  }

  private encryptAuthData(authData: any): Promise<string> {
    return this.appService
      .getEncryptionKey()
      .then((key) => CryptoHelper.encryptAuthData(key, authData));
  }

  private showEncryptionError() {
    this.errorMessage =
      'We are unable to secure your card details at this time. Please try again.';
    this.setState('isFilling', false);
    this.setState('error', true);
  }

  async authenticateMasterCardPayment(authData: any) {
    this.paymentProcessor = PaymentProcessor.MPGS;
    this.setState('verifyingTransfer', true);

    let encryptedAuthData: string;
    try {
      encryptedAuthData = await this.encryptAuthData(authData);
    } catch (err) {
      console.log(err);
      this.setState('verifyingTransfer', false);
      this.showEncryptionError();
      return;
    }

    const data = {
      cardRequestType: 'AUTHENTICATE_PAYER',
      transactionRef: this.reference,
      authData: encryptedAuthData,
      browser: navigator.userAgent,
      threeDSecureChallengeWindowSize: '390_X_400',
      acceptHeaders:
        'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7',
      colorDepth: screen.pixelDepth,
      javaEnabled: navigator.javaEnabled() ? true : false,
      javaScriptEnabled: true,
      language: navigator.language,
      screenHeight: screen.height,
      screenWidth: screen.width,
      timeZone: new Date().getTimezoneOffset(),
    };

    setTimeout(() => {
      this.continueAuthentication(data);
    }, 10000);
  }

  continueAuthentication(data: any) {
    this.appService.authenticateCardPayment(data).subscribe({
      next: (res: any) => {
        if (res?.success) {
          this.openMasterCardForm(res.data);
        } else {
          this.appService.invalidateEncryptionKey();
          this.errorMessage = StringHelper.getErrorMessage(res);
          this.setState('verifyingTransfer', false);
          this.setState('error', true);
          this.paymentFailed();
        }
      },
      error: (err: any) => {
        console.log(err);
        this.appService.invalidateEncryptionKey();
        this.errorMessage = StringHelper.getErrorMessage(err.error);
        this.setState('verifyingTransfer', false);
        this.setState('error', true);
        this.paymentFailed();
      },
    });
  }

  openMasterCardForm(data: any) {
    this.onRedirect.emit();
    this.trustedHTML = this.sanitizer.bypassSecurityTrustHtml(
      data.redirectHtml,
    );
    const iframe = document.getElementById(
      'threedscardinalTarget',
    ) as HTMLIFrameElement;
    iframe.style.cssText =
      'display: block;z-index: 999999999999999;background: #FFF;border: 0px none transparent;overflow-x: hidden;overflow-y: hidden;margin: 0;padding: 0;-webkit-tap-highlight-color: transparent;-webkit-touch-callout: none;position: fixed;left: 0;top: 0;width: 100%;height: 100%';
    iframe.src = 'about:blank';

    const handleLoad = () => {
      iframe.removeEventListener('load', handleLoad); // Remove the event listener after it fires
      this.checkIframeContentChange(); // detecting if iframe content has changed
    };

    iframe.addEventListener('load', handleLoad);

    const iWindow = iframe.contentWindow;
    iWindow?.document.open();
    iWindow?.document.write(data.redirectHtml);
    iWindow?.document.close();
    this.setState('loaded', true);
  }

  authenticateVerveMPGSPayment(data: any) {
    this.paymentProcessor = PaymentProcessor.MPGS;

    this.onRedirect.emit();
    this.setState('verifyingTransfer', true);

    const iframe = document.getElementById(
      'threedscardinalTarget',
    ) as HTMLIFrameElement;

    if (!iframe) {
      this.errorMessage = 'Unable to load verve-mpgs verification iframe';
      this.setState('error', true);
      return;
    }

    // Style iframe to be full screen
    iframe.style.cssText = `
      display: block;
      z-index: 999999999999999;
      background: #FFF;
      border: none;
      overflow: hidden;
      margin: 0;
      padding: 0;
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    `;

    // a form into the iframe and auto-submit it
    const html = `
      <html>
        <body onload="document.forms[0].submit()" style="margin:0">
          <form method="POST" action="${data.redirectHtml}">
            <input type="hidden" name="threeDSMethodData" value="${data.accessToken}" />
          </form>
        </body>
      </html>
    `;

    const handleLoad = () => {
      iframe.removeEventListener('load', handleLoad); // Remove the event listener after it fires
      this.checkIframeContentChange(); // detecting if iframe content has changed
    };

    iframe.addEventListener('load', handleLoad);

    const iframeWindow = iframe.contentWindow;
    if (iframeWindow?.document) {
      iframeWindow.document.open();
      iframeWindow.document.write(html);
      iframeWindow.document.close();
      this.setState('loaded', true);

      // iframe.onload = () => {
      //   this.checkIframeContentChange();
      // };
    } else {
      this.errorMessage = 'Unable to open verification form';
      this.setState('error', true);
    }
  }

  authenticateCyberSourcePayment(data: any) {
    this.setState('verifyingTransfer', true);
    const iframe = document.createElement('iframe');
    iframe.setAttribute('name', 'ddc-iframe');
    iframe.setAttribute('width', '10');
    iframe.setAttribute('height', '10');
    const html = `<!DOCTYPE html>
    <html lang="en">
    <body>
    <form id="form2" action=${data.deviceDataCollectionUrl} method="post">
      <input name="JWT" value=${data.accessToken}>
    </form>
    </body>
    <script type="text/javascript">
      var body = document.getElementsByTagName("body")[0];
      body.addEventListener("load", document.getElementById('form2').submit(), false);
    </script>
    </html>`;

    iframe.style.cssText = 'display: none';
    document.body.appendChild(iframe);
    iframe.src = 'about:blank';

    const iWindow = iframe.contentWindow;
    iWindow?.document.open();
    iWindow?.document.write(html);
    iWindow?.document.close();

    const handleLoad = () => {
      iframe.removeEventListener('load', handleLoad); // Remove the event listener after it fires
    };

    iframe.addEventListener('load', handleLoad);
  }

  // cybersource payer enrollment validation
  payerEnrollSubmit() {
    this.setState('verifyingTransfer', true);
    const data = {
      cardRequestType: 'PAYER_ENROLL',
      referenceId: this.referenceId,
      transactionRef: this.reference,
    };
    this.appService.enrollPayer(data).subscribe({
      next: (res: any) => {
        if (res?.success) {
          this.openCyberSourceForm(res.data);
        } else {
          this.errorMessage = StringHelper.getErrorMessage(res);
          this.setState('verifyingTransfer', false);
          this.setState('error', true);
        }
      },
      error: (err: any) => {
        console.log(err);
        this.errorMessage = StringHelper.getErrorMessage(err.error);
        this.setState('verifyingTransfer', false);
        this.setState('error', true);
      },
    });
  }

  openCyberSourceForm(data: any) {
    this.onRedirect.emit();
    this.paymentProcessor = PaymentProcessor.CYBS;
    const iframe = document.createElement('iframe');
    (iframe.setAttribute('frameBorder', '0'),
      iframe.setAttribute('allowtransparency', 'true'),
      iframe.setAttribute('id', 'cardinalTarget'));
    const html = `<!DOCTYPE html>
    <html lang="en">
    <head>
    <style>
      #form3 {
        opacity:0
      }
    </style>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta http-equiv="X-UA-Compatible" content="ie=edge">
    <title>CyberSource Checkout</title>
    </head>
    <body>
    <form id="form3" action=${data.stepUpUrl} method="post">
      <input name="JWT" value=${data.accessToken}>
    </form>
    </body>
    <script type="text/javascript">
      var body = document.getElementsByTagName("body")[0];
      body.addEventListener("load", document.getElementById('form3').submit(), false);
    </script>
    </html>`;

    iframe.style.cssText =
      'z-index: 999999999999999;background: #FFF;border: 0px none transparent;overflow-x: hidden;overflow-y: hidden;margin: 0;padding: 0;-webkit-tap-highlight-color: transparent;-webkit-touch-callout: none;position: fixed;left: 0;top: 0;width: 100%;height: 100%';
    document.body.appendChild(iframe);
    iframe.src = 'about:blank';

    const handleLoad = () => {
      iframe.removeEventListener('load', handleLoad); // Remove the event listener after it fires
      this.checkIframeContentChange(); // detecting if iframe content has changed
    };

    iframe.addEventListener('load', handleLoad);
    const iWindow = iframe.contentWindow;
    iWindow?.document.open();
    iWindow?.document.write(html);
    iframe.onload = () => {
      // detecting if iframe content has changed
      this.checkIframeContentChange();
    };
  }

  removeIFrame() {
    const frameId =
      this.paymentProcessor == 0 ? 'threedscardinalTarget' : 'cardinalTarget';
    const frame = document.getElementById(frameId) as HTMLIFrameElement;
    frame.parentNode?.removeChild(frame);
  }

  // confirmTransaction() {
  //   const data = {
  //     cardRequestType: 'CARD_PAYMENT_STATUS',
  //     transactionRef: this.reference,
  //   };
  //   this.appService.confirmCardPayment(data).subscribe({
  //     next: (res) => {
  //       this.verifyingTransfer = false;
  //     },
  //     error: (err) => {
  //       this.verifyingTransfer = false;
  //     },
  //   });
  // }

  confirmTransaction() {
    this.setState('verifyingTransfer', true);
    const data = {
      cardRequestType: 'CARD_PAYMENT_STATUS',
      transactionRef: this.reference,
    };
    this.appService.confirmCardPayment(data).subscribe({
      next: (res: ApiResponse) => {
        if (res?.success) {
          if (
            res.data.narration == 'IN_PROGRESS' ||
            res.data.statusCode == '90'
          ) {
            this.beginQuery();
            return;
          } else if (res.data.statusCode == '99') {
            this.errorMessage = res.data.narration || 'Unable to complete';
            console.log(this.errorMessage);
            this.setState('verifyingTransfer', false);
            this.setState('error', true);
            this.removeIFrame();
            this.paymentFailed();
          } else {
            this.setState('verifyingTransfer', false);
            this.removeIFrame();
            this.callback.url = res.data.redirectHtml;
            this.paymentDone();
          }
        }
      },
      error: (err) => {
        this.errorMessage = StringHelper.getErrorMessage(err.error);
        this.setState('verifyingTransfer', false);
        this.setState('error', true);
        this.paymentFailed();
      },
    });
  }

  beginQuery() {
    this.startInterval();
  }

  startInterval() {
    this.timer$ = timer(0, 10000).subscribe((tick: any) => {
      if (!this.isIntervalActive) {
        // Stop further execution if the interval is not active
        return;
      }

      if (tick == this.queryTime) {
        this.errorMessage = `We could not confirm your payment.`;

        setTimeout(() => {
          this.setState('verifyingTransfer', false);
          this.setState('error', true);
          this.paymentFailed();
        }, 5000);
      } else if (tick == this.queryTime + 2) {
        this.stopInterval();
        this.removeIFrame();
      } else {
        // Your API call, which will be performed every 10000 milliseconds
        // Approximately 20 minutes and 20 seconds
        this.queryTransaction();
      }
    });
  }

  stopInterval() {
    this.isIntervalActive = false;

    if (this.timer$) {
      this.timer$.unsubscribe();
    }
  }

  queryTransaction() {
    const data = {
      cardRequestType: 'CARD_PAYMENT_STATUS',
      transactionRef: this.reference,
    };
    this.appService.confirmCardPayment(data).subscribe({
      next: (res: ApiResponse) => {
        if (res?.success) {
          if (
            res.data.narration == 'IN_PROGRESS' ||
            res.data.statusCode == '90'
          ) {
            return;
          } else if (res.data.statusCode == '99') {
            this.errorMessage = res.data.narration || 'Unable to complete';
            this.setState('verifyingTransfer', false);
            this.setState('error', true);
            this.removeIFrame();
            this.stopInterval();
            this.paymentFailed();
          } else {
            this.setState('verifyingTransfer', false);
            this.removeIFrame();
            this.callback.url = res.data.redirectHtml;
            this.paymentDone();
            this.stopInterval();
          }
        }
      },
      error: (err) => {
        this.errorMessage = StringHelper.getErrorMessage(err.error);
        this.setState('verifyingTransfer', false);
        this.setState('error', true);
        this.removeIFrame();
        this.stopInterval();
        this.paymentFailed();
      },
    });
  }

  setTransaction() {
    this.setState('verifyingTransfer', true);
    const data = {
      cardRequestType: '',
      otp: this.otpCode,
      transactionRef: this.reference,
    };

    if (this.cardType == 'afrigo') {
      data['cardRequestType'] = 'PAYMENT_CONFIRMATION';
    } else {
      data['cardRequestType'] = 'VALIDATE_CARD_OTP';
    }

    this.appService.authenticateCardPayment(data).subscribe({
      next: (res: any) => {
        if (res?.success) {
          this.responseData = res.data;
          this.setState('verifyingTransfer', false);
          this.callback.url = res.data.redirectHtml;
          this.paymentDone();
        }
      },
      error: (err: any) => {
        console.log(err);
        this.errorMessage = StringHelper.getErrorMessage(err.error);
        this.setState('pinSection', false);
        this.setState('verifyingTransfer', false);
        this.setState('error', true);
        this.paymentFailed();
      },
    });
  }

  formatTime(value: number) {
    `${Math.floor(value / 60)}:${('0' + (value % 60)).slice(-2)}`;
  }

  startCountDown() {
    this.timer(this.time_in_minutes);
  }

  stopCountDown() {
    clearInterval(this.timerInterval);
  }

  timer(minute: number) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = '0';
    let statSec: number = 60;

    const prefix = minute < 10 ? '0' : '';

    this.timerInterval = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = '0' + statSec;
      } else textSec = statSec;

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  reInitialize() {
    this.stopCountDown();
    setTimeout(() => {
      this.startCountDown();
    }, 1000);
  }

  maskCustomerPhoneNumber(phoneNumber: string): string {
    if (phoneNumber.length === 11) {
      return `${phoneNumber.substring(0, 4)}****${phoneNumber.substring(
        8,
        11,
      )}`;
    } else {
      return phoneNumber;
    }
  }

  maskCustomerEmail(email: string): string {
    let maskEmail = '';
    const prefix = email.substring(0, email.lastIndexOf('@'));
    const postfix = email.substring(email.lastIndexOf('@'));

    for (let i = 0; i < prefix.length; i++) {
      if (
        i === 0 ||
        (i === 1 && prefix.length >= 10) ||
        i === prefix.length - 1 ||
        (i === prefix.length - 2 && prefix.length >= 10)
      ) {
        maskEmail = maskEmail + prefix[i].toString();
      } else {
        maskEmail = maskEmail + '*';
      }
    }
    maskEmail = maskEmail + postfix;
    return maskEmail;
  }

  checkDigit(event: any) {
    const code = event.which ? event.which : event.keyCode;

    if ((code < 48 || code > 57) && code > 31) {
      return false;
    }

    return true;
  }

  getCardType(number: any) {
    // visa
    var re = new RegExp('^4[0-9]');
    if (number.match(re) != null) return 'visa';

    // Mastercard
    // Updated for Mastercard 2017 BINs expansion
    re = new RegExp('^(2[221-720][0-9])|(5[1-5][0-9])');
    if (number.match(re) != null) return 'mastercard';
    // Afrigo
    re = new RegExp('^564');
    if (number.match(re) != null && number.length === 18) return 'afrigo';

    // Verve
    if (number.length === 19) return 'verve';

    return '';
  }

  private groupDigits(digits: string, size: number, separator: string) {
    const groups: string[] = [];
    for (let i = 0; i < digits.length; i += size) {
      groups.push(digits.slice(i, i + size));
    }
    return groups.join(separator);
  }

  // Index just past the Nth digit of the formatted value, so the caret keeps
  // its place relative to the digits the user typed rather than to separators
  // this handler re-derives on every keystroke.
  private caretForDigitCount(formatted: string, digitCount: number) {
    if (digitCount <= 0) return 0;
    let seen = 0;
    for (let i = 0; i < formatted.length; i++) {
      if (/\d/.test(formatted[i]) && ++seen === digitCount) return i + 1;
    }
    return formatted.length;
  }

  private applyDigitsOnly(
    event: Event,
    controlName: string,
    maxDigits: number,
    format: (digits: string) => string = (digits) => digits,
  ) {
    const el = event.target as HTMLInputElement;
    const caret = el.selectionStart ?? el.value.length;
    const digitsBeforeCaret = el.value
      .slice(0, caret)
      .replace(/[^\d]/g, '').length;

    const formatted = format(
      el.value.replace(/[^\d]/g, '').slice(0, maxDigits),
    );
    this.cardPaymentForm.get(controlName)!.setValue(formatted);

    const newCaret = this.caretForDigitCount(formatted, digitsBeforeCaret);
    el.setSelectionRange(newCaret, newCaret);
  }

  onCardNumberInput(event: Event) {
    this.applyDigitsOnly(event, 'cardNo', 19, (digits) =>
      this.groupDigits(digits, 4, ' '),
    );
  }

  onExpiryInput(event: Event) {
    this.applyDigitsOnly(event, 'expiryDate', 4, (digits) =>
      digits.length > 2 ? `${digits.slice(0, 2)}/${digits.slice(2)}` : digits,
    );
  }

  onCvvInput(event: Event) {
    this.applyDigitsOnly(event, 'cvv', 3);
  }

  onPinInput(event: Event) {
    this.applyDigitsOnly(event, 'pin', 6);
  }

  private applyCardType(value: string) {
    const digits = (value || '').replace(/[^\d]/g, '');
    const patterns: Record<string, RegExp> = {
      visa: /^4[0-9]{6,}$/,
      verve: /^((506(0|1))|(507(8|9))|(6500))(\d{12}|\d{15})$/,
      mastercard:
        /(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}/,
      afrigo: /^564[0-9]{15}/,
    };

    this.cardType = '';
    for (const cardType in patterns) {
      if (patterns[cardType].test(digits)) {
        this.cardType = cardType;
        break;
      }
    }

    this.showPin = this.cardType === 'verve';
    this.updatePinValidator();
  }

  checkBin(bin: string) {
    this.binCheckSubject.next(bin);
  }

  applyBinResult(data: { international: boolean; fee?: number }) {
    this.isInternationalCard = !!data.international;
    const feeMinor =
      this.isInternationalCard && data.fee != null
        ? data.fee
        : this.transactionFees.WEB_CARD;
    this.amount = StringHelper.toMajorAmount(
      +this.transactionData.amount + feeMinor,
    );
    this.onFeeChange.emit({
      amount: this.amount,
      fee: StringHelper.toMajorAmount(feeMinor),
    });

    // Survives the form being cleared on a failed payment and a tab switch away
    // and back. Domestic results are stored too, so entering a local card after
    // an international one overwrites the stored fee instead of leaving it stale.
    if (this.reference) {
      this.appService.setCardFeeState({
        reference: this.reference,
        international: this.isInternationalCard,
        feeMinor,
      });
    }

    this.cd.detectChanges();
  }

  private evaluateBinForPan(rawValue: string) {
    const digitsOnly = (rawValue || '').replace(/[^\d]/g, '');
    if (digitsOnly.length >= 8) {
      const bin = digitsOnly.slice(0, 8);
      if (bin !== this.lastBinChecked) {
        this.lastBinChecked = bin;
        this.checkBin(bin);
      }
    } else if (this.lastBinChecked !== null) {
      this.lastBinChecked = null;
      if (this.isInternationalCard) {
        this.applyBinResult({ international: false });
      }
    }
  }

  private updatePinValidator() {
    const pinControl = this.cardPaymentForm.get('pin');
    if (!pinControl) return;
    if (this.showPin) {
      pinControl.setValidators([
        Validators.required,
        Validators.pattern(/^\d+$/),
      ]);
    } else {
      pinControl.clearValidators();
      pinControl.setValue('');
    }
    pinControl.updateValueAndValidity();
  }

  validateCardNumber(number: string) {
    //Check if the number contains only numeric value
    //and is of between 13 to 19 digits
    const regex = new RegExp('^[0-9]{13,19}$');
    if (!regex.test(number)) {
      return false;
    }

    return this.luhnCheck(number);
  }

  luhnCheck = (val: string) => {
    let checksum = 0; // running checksum total
    let j = 1; // takes value of 1 or 2

    // Process each digit one by one starting from the last
    for (let i = val.length - 1; i >= 0; i--) {
      let calc = 0;
      // Extract the next digit and multiply by 1 or 2 on alternative digits.
      calc = Number(val.charAt(i)) * j;

      // If the result is in two digits add 1 to the checksum total
      if (calc > 9) {
        checksum = checksum + 1;
        calc = calc - 10;
      }

      // Add the units element to the checksum total
      checksum = checksum + calc;

      // Switch the value of j
      if (j == 1) {
        j = 2;
      } else {
        j = 1;
      }
    }

    //Check if it is divisible by 10 or not.
    return checksum % 10 == 0;
  };

  onOtpChange(otp: string): void {
    this.otpCode = otp;
  }

  setOTP(otp: string[]) {
    this.otpCode = otp.join('');
  }

  onVerify() {
    this.setTransaction();
  }

  getCountries() {
    this.appService.getCountries().subscribe({
      next: (res: any) => {
        if (res) {
          this.countries = res;
        }
      },
      error: (err: any) => {
        console.log(err);
      },
    });
  }

  countrySelected(event: any) {
    const value = event.target.value;

    const countryIso = StringHelper.fetchTypeByValue(
      this.countries,
      value,
    ).iso2;

    this.appService.getStates(countryIso).subscribe({
      next: (res: any) => {
        if (res) {
          let temp = res.slice();
          temp.sort((a: any, b: any) => {
            return a.name.localeCompare(b.name);
          });
          this.localities = temp;
        }
      },
      error: (err: any) => {
        console.log(err);
      },
    });
  }

  paymentDone() {
    this.onComplete.emit(this.callback);
    const domEvent = new CustomEvent('paymentDone');
    this.el.nativeElement.dispatchEvent(domEvent);
  }

  paymentFailed() {
    const error = {
      reference: this.reference,
      message: this.errorMessage,
      status: 'failure',
    };
    postTransactionMessage('error', error);
    const domEvent = new CustomEvent('paymentFailed');
    this.el.nativeElement.dispatchEvent(domEvent);
  }

  verifyTransfer() {
    this.setState('verifyingTransfer', true);
    setTimeout(() => {
      this.paymentDone();
    }, 3000);
  }

  enterPin() {
    this.state.pinSection = true;
  }

  tryAgain() {
    this.setState('error', false);
  }

  saveCard(event: any) {
    const checked = event.target.checked;
    this.tokenizeCard = checked ? true : false;
  }

  fetchSavedCards() {
    this.setState('verifyingTransfer', true);
    const data = {
      email: this.transactionData.email,
      merchantApiKey: this.transactionData.key,
    };
    this.appService.fetchSavedCards(data).subscribe({
      next: (res: ApiResponse) => {
        if (res?.success) {
          this.cards = res.data;
          // Neither saved card is selected yet — don't carry over an
          // international fee (or lastBinChecked dedup) left behind by
          // whatever was typed in the new-card form before switching here.
          this.lastBinChecked = null;
          this.applyBinResult({ international: false });
          this.setState('verifyingTransfer', false);
          this.setState('showSavedCard', true);
          setTimeout(() => {
            this.showSavedCardsArrow = StringHelper.hasScrollDown(
              this.savedCardsList?.nativeElement,
            );
          }, 0);
        }
      },
      error: (err) => {
        this.errorMessage = StringHelper.getErrorMessage(err.error);
        this.setState('verifyingTransfer', false);
        this.setState('error', true);
      },
    });
  }

  goBackToCardForm() {
    this.setState('showSavedCard', false);
    this.setState('isFilling', true);
    this.lastBinChecked = null;
    this.applyBinResult({ international: false });
  }

  selectSavedCard(card: any) {
    this.paymentCard = card;
    this.cardChecked = true;

    // The saved card carries its own 8-digit bin; cardPan is masked and only
    // good for display.
    const bin = String(card?.bin || '').replace(/[^\d]/g, '');
    if (bin.length === 8 && bin !== this.lastBinChecked) {
      this.lastBinChecked = bin;
      this.checkBin(bin);
    }
  }

  onSavedCardsScroll() {
    this.showSavedCardsArrow = StringHelper.hasScrollDown(
      this.savedCardsList?.nativeElement,
    );
  }

  scrollSavedCardsDown() {
    StringHelper.scrollElementBy(this.savedCardsList?.nativeElement);
  }

  confirmPayment() {
    this.setState('showSavedCard', false);
    this.setState('verifyingTransfer', true);

    const data: any = {
      cardRequestType: 'TOKEN_PAYMENT',
      email: this.transactionData.email,
      transactionRef: this.reference,
      currency: this.transactionData.currency,
      cardId: this.paymentCard.cardId,
    };

    this.appService.confirmTokenizedCardPayment(data).subscribe({
      next: (res) => {
        if (res?.success) {
          this.loading = false;
          switch (res.data.code) {
            case '00':
              this.paymentDone();
              break;
            case '01':
              this.setState('verifyingTransfer', false);
              this.setState('pinSection', true);
              break;
            case '02':
              this.setState('verifyingTransfer', false);
              this.openVisaForm(res.data);
              break;
            case '04':
              this.authenticateCyberSourcePayment(res.data);
              break;
            default:
              this.errorMessage =
                'We are unable to complete your request at this time, Please try again later';
              this.setState('verifyingTransfer', false);
              this.setState('error', true);
              this.paymentFailed();
              break;
          }
        } else {
          this.errorMessage = StringHelper.getErrorMessage(res);
          this.setState('verifyingTransfer', false);
          this.setState('isFilling', false);
          this.setState('error', true);
          this.cardPaymentForm.reset(undefined, { emitEvent: false });
          this.paymentFailed();
        }
      },
      error: (err) => {
        console.log(err);
        this.errorMessage = StringHelper.getErrorMessage(err.error);
        this.setState('verifyingTransfer', false);
        this.setState('isFilling', false);
        this.setState('error', true);
        this.cardPaymentForm.reset(undefined, { emitEvent: false });
        this.paymentFailed();
      },
    });
  }

  ngOnDestroy(): void {
    this.timer$?.unsubscribe();
    this.scriptLoaded$.complete();
    this.cardNoSub?.unsubscribe();
    this.binCheckSub?.unsubscribe();
  }
}
